module.exports = __webpack_public_path__ + "media/tam ngaan táng wan lá mĕe plòh táng wan loie.975a3396.mp3";